import Config from "../config.js";
import { createRequestOptions } from "./utils";
import { get } from "lodash";

export default () => {
  return Object.freeze({
    getSSOLink: async (userId, appId) => {
      const options = createRequestOptions({ userId, appId });

      const result = await fetch(
        Config.serverUrl + "/GetPhysiotecSSOLink",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },
    syncPhysioLiberary: async (userId, appId) => {
      const options = createRequestOptions({ userId, appId });

      const result = await fetch(
        Config.serverUrl + "/SyncPhysioLibrary",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },
    getIntegrationEnabled: async ( appId) => {
      const options = createRequestOptions({ appId });

      const result = await fetch(
        Config.serverUrl + "/GetPhysioIntegrationEnabled",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },
    requestPhsyioAccess: async ( appId) => {
      const options = createRequestOptions({ appId });

      const result = await fetch(
        Config.serverUrl + "/RequestPhsyioAccess",
        options
      );

      const response = await result.json();


      return get(response, "response");
    },
  });
};



// WEBPACK FOOTER //
// ./src/services/physiotec.js